import axiosInstance from "../server/axios";

const getAuthHeaders = () => {
  const token = localStorage.getItem('authToken');
  return {
    Authorization: `Bearer ${token}`,
    'Content-Type': 'application/json',
  };
};





// Soumettre une demande de remboursement
export const submitRefundRequest = async (orderId, raison) => {
  try{
 const response = await axiosInstance.post(`/remboursement/soumettre/${orderId}`, {
    raison: raison
  }, {
    headers: getAuthHeaders(),
     timeout: 10000,
  });
  return response.data;
  }catch(error){
    throw error;
  }
 
};

// Obtenir les demandes de remboursement de l'utilisateur
export const getUserRefundRequests = async () => {
  const response = await axiosInstance.get('/remboursement/mes-demandes', {
    headers: getAuthHeaders(),
  });
  return response.data;
};

// Annuler une demande de remboursement
export const cancelRefundRequest = async (requestId) => {
  const response = await axiosInstance.delete(`/remboursement/annuler/${requestId}`, {
    headers: getAuthHeaders(),
  });
  return response.data;
};

export const getUserOrders = async (filters = {}) => {
  const params = {};
  
  if (filters.status && filters.status !== 'all') {
    params.status = filters.status;
  }
  if (filters.startDate) {
    params.start_date = filters.startDate.format('YYYY-MM-DD');
  }
  if (filters.endDate) {
    params.end_date = filters.endDate.format('YYYY-MM-DD');
  }
  if (filters.search) {
    params.search = filters.search;
  }
  
  const response = await axiosInstance.get('/mes-achats', {
    headers: getAuthHeaders(),
    params: params
  });
  return response.data;
};


export const getOrderDetails = async (orderId) => {
  const response = await axiosInstance.get(`/mes-achats/${orderId}`, {
    headers: getAuthHeaders(),
  });
  return response.data;
};



// API pour les ventes
export const getUserVentes = async (filters = {}) => {
  const params = {};
  
  if (filters.status && filters.status !== 'all') {
    params.status = filters.status;
  }
  if (filters.startDate) {
    params.start_date = filters.startDate.format('YYYY-MM-DD');
  }
  if (filters.endDate) {
    params.end_date = filters.endDate.format('YYYY-MM-DD');
  }
  if (filters.search) {
    params.search = filters.search;
  }
  if (filters.type_id && filters.type_id !== 'all') {
    params.type_id = filters.type_id;
  }
  if (filters.methode_id && filters.methode_id !== 'all') {
    params.methode_id = filters.methode_id;
  }
  if (filters.per_page) {
    params.per_page = filters.per_page;
  }
  
  const response = await axiosInstance.get('/mes-ventes', {
    headers: getAuthHeaders(),
    params: params
  });
  return response.data;
};





// couponApi.js
export const getUserCoupons = async (type = 'all') => {
  const response = await axiosInstance.get(`/coupons/all?type=${type}`, {
    headers: getAuthHeaders(),
  });
  return response.data.data; // This returns { global: [], assigned: [] }
};

export const getGlobalCoupons = async () => {
  const response = await axiosInstance.get('/coupons/global', {
    headers: getAuthHeaders(),
  });
  return response.data.data; // Extract the data array
};

export const getAssignedCoupons = async () => {
  const response = await axiosInstance.get('/coupons/assigned', {
    headers: getAuthHeaders(),
  });
  return response.data.data; // Extract the data array
};

export const getUsedCoupons = async () => {
  const response = await axiosInstance.get('/coupons/used', {
    headers: getAuthHeaders(),
  });
  return response.data.data; // Extract the data array
};

export const getExpiredCoupons = async () => {
  const response = await axiosInstance.get('/coupons/expired', {
    headers: getAuthHeaders(),
  });
  return response.data.data; // Extract the data array
};
// Unified Transactions API
export const getUserTransactions = async (filters = {}) => {
  const params = {};
  
  // Common filters
  if (filters.transaction_type && filters.transaction_type !== 'all') {
    params.transaction_type = filters.transaction_type;
  }
  if (filters.status && filters.status !== 'all') {
    params.status = filters.status;
  }
  if (filters.startDate) {
    params.start_date = filters.startDate.format('YYYY-MM-DD');
  }
  if (filters.endDate) {
    params.end_date = filters.endDate.format('YYYY-MM-DD');
  }
  if (filters.search) {
    params.search = filters.search;
  }
  if (filters.page) {
    params.page = filters.page;
  }
  if (filters.per_page) {
    params.per_page = filters.per_page;
  }
  
  const response = await axiosInstance.get('/mes-transactions', {
    headers: getAuthHeaders(),
    params: params
  });
  return response.data;
};


